import type { ReactNode } from "react";
import { PageWrapper } from "@/deps/ui-library";

/**
 * A screen's header on RDS `PageWrapper` parts (ADR-0054): the title, an optional mono document
 * number beside it, the muted line under it, and at most two actions on the right. The frame
 * around the screen (its padding and width) is the shell's `main`.
 */
export function PageHeader({
  title,
  number,
  subtitle,
  actions,
}: {
  title: string;
  number?: string;
  subtitle?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <PageWrapper.Header className="flex-row flex-wrap items-start justify-between gap-3">
      <div className="min-w-0">
        <div className="flex items-baseline gap-2.5">
          <PageWrapper.Title className="text-xl tracking-[-0.02em]">{title}</PageWrapper.Title>
          {number && <span className="num text-sm text-primary">{number}</span>}
        </div>
        {subtitle && <PageWrapper.Description>{subtitle}</PageWrapper.Description>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </PageWrapper.Header>
  );
}
